import { yoe } from '@/api/common/master-lists'

export default {
  namespaced: true,

  state () {
    return {
      loading: false,
      items: sessionStorage.getItem('yoes')
        ? JSON.parse(sessionStorage.getItem('yoes'))
        : []
    }
  },
  mutations: {
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    },
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} loading
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Fetch all YearsOfExperienceRange records
     *
     * @param { commit, dispatch, state}
     */
    fetch ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return yoe.index()
        .then(({ data }) => {
          const reverseData = data.reverse()
          commit('SET_ITEMS', reverseData)

          sessionStorage.setItem('yoes', JSON.stringify(reverseData))
        })
        .catch(({ response }) => {
          dispatch('httpException/handle', response, { root: true })
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    }
  }
}
